import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { OrderType } from 'config/Api.Config';
import VehicleClass from 'models/productManagement/vehicleClass/Model.VehicleClass';
import VehicleMake from 'models/productManagement/vehicleMake/Model.VehicleMake';
import { useVehicleModelProvider } from '../VehicleModel.Hooks';

export default function VehicleModelFilters() {
  const { lang } = getLocales();
  const { listApi } = useVehicleModelProvider();
  const vehicleMakeApi = useApi({ action: VehicleMake.list });
  const vehicleClassApi = useApi({ action: VehicleClass.list });

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      filters={listApi.body}
      onFilter={(newFilters) => listApi.execute({ ...newFilters, offset: 0 })}
      onReset={listApi.reset}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      headerActions={
        <DropdownButton
          buttonMedia={<Icon class="fas-sort" />}
          horizontalPosition="auto_fixed"
          verticalPosition="auto_fixed"
          htmlElementProps={{ title: lang.sort }}
          subcomponents={ThemeDropdownButtonPopup}
          dropdownOptions={
            <>
              <Button
                class={ThemeButtonMenuItem}
                render={lang.newerFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: undefined,
                  orderType: undefined,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.olderFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'id',
                  orderType: OrderType.asc,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.ascendingByName}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.asc,
                  thenType: [OrderType.asc, OrderType.asc, OrderType.asc],
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.descendingByName}
                media={<Icon class="fas-caret-down" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.desc,
                  thenType: [OrderType.desc, OrderType.desc, OrderType.desc],
                })}
              />
            </>
          }
        />
      }
      render={({ tempFilters, setFilters }) => (
        <>
          <SelectInput
            name="vehicleMakeCodeId"
            label={lang.vehicleMake}
            data={vehicleMakeApi?.payload?.data?.map((item) => ({
              id: item.id,
              title: item.makeCode,
              icon: <Icon class="fas-car" />,
            }))}
            isMultiselect
            value={tempFilters?.vehicleMakeCodeId}
            onChange={({ vehicleMakeCodeId }) => setFilters({ ...tempFilters, vehicleMakeCodeId })}
            icon={<Icon class="fas-car" />}
          />
          <SelectInput
            name="vehicleClassId"
            label={lang.vehicleClass}
            data={vehicleClassApi?.payload?.data?.map((item) => ({
              id: item.id,
              title: `${item.primaryCode} - ${item.secondaryCode}`,
              icon: <Icon class="fas-oil-can" />,
            }))}
            isMultiselect
            value={tempFilters?.vehicleClassId}
            onChange={({ vehicleClassId }) => setFilters({ ...tempFilters, vehicleClassId })}
            icon={<Icon class="fas-oil-can" />}
          />
        </>
      )}
    />
  );
}
